module.exports = __webpack_public_path__ + "static/img/Mitchell-Moses.ce83077.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitchell-Moses.jpg
// module id = AwUb
// module chunks = 0